import api from "./core";

const basePath = "api/{{serverSegment}}/IcdCode";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(filter, extraHeaders = {}) {
    return api.post(`${basePath}`, filter, extraHeaders);
  },
  count(filter, extraHeaders = {}) {
    return api.post(`${basePath}/SearchCount`, filter, extraHeaders);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  }
};
